export const chartComponentStyle = {
  barChartContainer: {
    default: {
      backgroundColor: "var(--fifth)",
      height: "280px",
      padding: "15px 10px ",
      margin: "10px -15px",
      boxShadow: "rgb(207, 207, 207) 3px 3px 5px",
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/Dashboard/styles/chartComponentsStyle.js